var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-trendyol-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.channelName")))]),
              _vm._v(" "),
              _c(
                "a-form-item",
                [
                  _c("a-input", {
                    attrs: { placeholder: _vm.$t("message.channelName") },
                    model: {
                      value: _vm.form.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelName", $$v)
                      },
                      expression: "form.channelName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.trendyolSellerIdLabel"))),
              ]),
              _vm._v(" "),
              _c("a-input", {
                attrs: {
                  placeholder: _vm.$t("message.trendyolSellerIdPlaceholder"),
                },
                model: {
                  value: _vm.form.sellerId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sellerId", $$v)
                  },
                  expression: "form.sellerId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.trendyolApiKeyFieldLabel"))),
              ]),
              _vm._v(" "),
              _c("a-input", {
                attrs: {
                  placeholder: _vm.$t("message.trendyolApiKeyPlaceholder"),
                },
                model: {
                  value: _vm.form.apiKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "apiKey", $$v)
                  },
                  expression: "form.apiKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.trendyolApiSecretKeyLabel"))),
              ]),
              _vm._v(" "),
              _c("a-input", {
                attrs: {
                  placeholder: _vm.$t(
                    "message.trendyolApiSecretKeyPlaceholder"
                  ),
                },
                model: {
                  value: _vm.form.apiSecretKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "apiSecretKey", $$v)
                  },
                  expression: "form.apiSecretKey",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("wp.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [_vm._v(_vm._s(_vm.$t("message.save")) + "\n            ")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }